/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/10/8 17:45
 * @FileName: questionAndAnswer.js
 * @LastEditor: 2022/10/8 17:45
 * @Name: questionAndAnswer
 */

const questionAndAnswer = {
  routes: [
    {
      path: '/questionAndAnswer',
      name: 'questionAndAnswer',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/question-and-answer/question-and-answer.vue')
    }
  ]
};
export default questionAndAnswer;



// WEBPACK FOOTER //
// ./src/project/router/questionAndAnswer.js